export default __webpack_public_path__ + "static/favicon-8a28b35ce0e6339c3bb47c25286c544e.png";